import { render, staticRenderFns } from "./CustomChipLink.vue?vue&type=template&id=48262258&"
import script from "./CustomChipLink.vue?vue&type=script&lang=ts&"
export * from "./CustomChipLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports